import gql from 'graphql-tag';

const DEMOGRAPH_JOB_PROGRESS_SUBSCRIPTION = gql`
  subscription demographJobProgress($orgId: ID!) {
    demographJobProgress(orgId: $orgId) {
      audienceDemographId
      jobType
      status
      progress
      message
      metadata
    }
  }
`;

export default DEMOGRAPH_JOB_PROGRESS_SUBSCRIPTION;
